import _jsx from "@babel/runtime/helpers/jsx";
import PropTypes from 'prop-types';
import React from 'react';
import { prefix, splitBsProps, bsClass } from './utils/bootstrapUtils';
import Collapse from '../Collapse/Collapse.js';
import { PanelContext } from '../Panel/PanelContext';
class PanelCollapse extends React.Component {
  render() {
    const {
      children
    } = this.props;
    const {
      headingId,
      bodyId,
      bsClass: _bsClass,
      expanded
    } = this.context || {};
    const [bsProps, props] = splitBsProps(this.props);
    bsProps.bsClass = _bsClass || bsProps.bsClass;
    if (headingId && bodyId) {
      props.id = bodyId;
      props.role = props.role || 'tabpanel';
      props['aria-labelledby'] = headingId;
    }
    return /*#__PURE__*/React.createElement(Collapse, Object.assign({
      in: expanded
    }, props), /*#__PURE__*/_jsx("div", {
      className: prefix(bsProps, 'collapse')
    }, void 0, children));
  }
}
PanelCollapse.contextType = PanelContext;
export default bsClass('panel', PanelCollapse);